import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "📐", key: "furnitureLayout" },
  { emoji: "🎨", key: "colorPalette" },
  { emoji: "💡", key: "lighting" },
  { emoji: "🪴", key: "decorAccessories" },
]

export default function HomeMustTrackPage() {
  return <RadioCardListPage translationKey="homeMustTrack" options={OPTIONS} />
}
